module.exports = __webpack_public_path__ + "assets/img/push-ru.1ae7c677.jpg";